export const AI_CAPABILITIES = [
  { name: 'Natural Language Processing', description: 'Advanced text understanding and generation' },
  { name: 'Predictive Analytics', description: 'Data-driven forecasting and insights' },
  { name: 'Computer Vision', description: 'Image and video analysis capabilities' },
  { name: 'Process Automation', description: 'Intelligent workflow automation' },
  { name: 'Sentiment Analysis', description: 'Real-time sentiment and emotion detection' },
  { name: 'Recommendation Engine', description: 'Personalized content and service recommendations' },
];
